export enum ActionStatus {
    pending = 'pending',
    completed = 'completed',
    reverted = 'reverted',
}
